import logo from "../../assets/icons/logo2.png";
import { Link, useLocation } from "react-router-dom";
import "../../assets/styles/main-styles.css";
import {
  User2,
  Home,
  LayoutList,
  BookOpen,
  Stethoscope,
  Building2,
} from "lucide-react";

const Header = ({ userName }) => {
  const location = useLocation();

  const headerMenu = [
    { id: 1, title: "صفحه اصلی", url: "/" },
    { id: 2, title: "پزشکان", url: "/doctors" },
    { id: 3, title: "مراکز درمانی", url: "/centers" },
    { id: 4, title: "مجله سلامت", url: "https://blog.medizen.ir" },
  ];

  const getCleanPath = (rawUrl) => {
    if (!rawUrl) return "/";
    if (rawUrl.startsWith("http")) return rawUrl;
    return rawUrl;
  };

  const isActive = (rawUrl) => {
    const cleanPath = getCleanPath(rawUrl);
    if (cleanPath.startsWith("http")) return false;
    return location.pathname === cleanPath;
  };

  const getMobileIcon = (url) => {
    if (url === "/") return <Home size={18} />;
    if (url === "/articles") return <BookOpen size={18} />;
    if (url === "/doctors") return <Stethoscope size={18} />;
    if (url === "/centers") return <Building2 size={18} />;
    return <LayoutList size={18} />;
  };

  return (
    <>
      <div className="font-medium relative flex justify-center mb-[60px] 
      lg:mb-[100px] xl:mb-[120px] w-full">
        <div
          className="py-2 shadow-[5px_5px_20px_rgb(0,0,0,0.04)] border-b
          border-gray-100 text-[15px] flex justify-between
          fixed w-full z-[60] bg-white items-center"
        >
          <div className="flex items-center pr-6 md:pr-[8.3%]">
            <div className="items-center">
              <Link to="/">
                <img
                  src={logo}
                  className="h-8 lg:h-10 xl:h-14 object-contain"
                  alt="HamVet"
                />
              </Link>
            </div>
          </div>

          <div
            className="w-full text-[14.5px] justify-center gap-5 text-gray-600/80
            items-center hidden lg:flex"
          >
            {headerMenu.map((item) => {
              const cleanPath = getCleanPath(item.url);
              const isExternal = cleanPath.startsWith("http");

              return isExternal ? (
                <a
                  key={item.id}
                  href={cleanPath}
                  target="_self"
                  rel="noreferrer"
                  className="hover:scale-95 transition-all text-opacity-80"
                >
                  {item.title}
                </a>
              ) : (
                <Link
                  key={item.id}
                  to={cleanPath}
                  className={`hover:scale-95 transition-all ${
                    isActive(item.url) ? "text-purple" : "text-opacity-80"
                  }`}
                >
                  {item.title}
                </Link>
              );
            })}
          </div>

          <a
            href="https://medizen.ir/panel"
            target="_self"
            className="items-center ml-6 md:ml-[8.3%] bg-gray-50 w-fit h-8 lg:h-9 border
             border-gray-300 text-[13px] md:text-[14px]
            transition-all hover:bg-purple hover:border-purple hover:text-white flex 
            justify-center items-center rounded-[11px] pl-3 pr-2 lg:pl-5 lg:pr-3.5 group"
          >
            <User2 className="h-[15px] md:h-[17px] text-gray-700 group-hover:text-white transition-colors" />
            <span className="text-gray-700 group-hover:text-white transition-colors">
              {userName || "پنل کاربری"}
            </span>
          </a>
        </div>
      </div>

      <div
        className="lg:hidden fixed bottom-0 left-0 w-full bg-white/95
        backdrop-blur-sm shadow-[0_-4px_15px_rgba(0,0,0,0.04)] z-[60] flex
        justify-around items-center px-2 py-3 rounded-t-2xl border-t border-gray-100 pb-safe"
      >
        {headerMenu.map((item) => {
          const cleanPath = getCleanPath(item.url);
          const active = isActive(item.url);
          const isExternal = cleanPath.startsWith("http");

          const NavContent = () => (
            <div
              className={`flex flex-col items-center justify-center gap-1.5
              transition-all duration-300 ${
                active
                  ? "text-purple translate-y-[-2px]"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              {getMobileIcon(item.url)}
              <span
                className={`text-[10px] whitespace-nowrap ${
                  active ? "font-bold" : "font-medium"
                }`}
              >
                {item.title}
              </span>
            </div>
          );

          return isExternal ? (
            <a
              key={item.id}
              href={cleanPath}
              target="_self"
              rel="noreferrer"
              className="flex-1 flex justify-center"
            >
              <NavContent />
            </a>
          ) : (
            <Link
              key={item.id}
              to={cleanPath}
              className="flex-1 flex justify-center"
            >
              <NavContent />
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default Header;
